import PersonalBookingPage from './PersonalBookingPage';

export default PersonalBookingPage;
